module.exports = __webpack_public_path__ + "static/img/feedback.99e0048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feedback.png
// module id = dVCQ
// module chunks = 0